import "./headerUnit.css";
import sortDownIcon from "../../assets/SortedByDown.svg";
import sortUpIcon from "../../assets/SortedByUp.svg";
import sortedByIcon from "../../assets/SortedBy.svg";
import { SortDirection } from "@tanstack/react-table";

export type HeaderUnitProps = {
  value: string;
  isSorted: false | SortDirection;
  onClicked: () => void;
};

const HeaderUnit: React.FC<HeaderUnitProps> = ({ value, isSorted, onClicked }) => {
  return (
    <button
      className="header-unit"
      onClick={() => {
        onClicked();
      }}
    >
      <div className="overlay"></div>
      <span className="body-medium">{value}</span>
      {isSorted ? (
        isSorted === "asc" ? (
          <img alt="Sort Up Icon" src={sortUpIcon}></img>
        ) : (
          <img alt="Sort Down Icon" src={sortDownIcon}></img>
        )
      ) : (
        <img className="sort-by-icon" alt="Sort By Icon" src={sortedByIcon}></img>
      )}
    </button>
  );
};

export default HeaderUnit;
